import { usePropertySearch } from './usePropertySearch';
import { usePropertySearchRequest } from '../../../public-map/presentation/hooks/usePropertySearchRequest';

export function useFilteredProperties() {
  const request = usePropertySearchRequest('properties');
  return usePropertySearch(request);
}
